import { Dayjs } from 'dayjs';
import { WeekAvailable } from '../models/calendar/Calendar.model';

export const isOutsideCalendarHours = (
    start: Dayjs,
    end: Dayjs,
    weekAvailable: WeekAvailable[]
): boolean => {
    if (!weekAvailable || weekAvailable.length === 0) {
        return false; // No restrictions set on this calendar
    }

    // Map Dayjs day (0=Sunday, 1=Monday... 6=Saturday) to Calendar internal numberDay (0=Monday... 6=Sunday)
    const mapDayjsToInternalDay = (jsDay: number) => {
        return jsDay === 0 ? 6 : jsDay - 1;
    };

    const startInternalDay = mapDayjsToInternalDay(start.day());
    const dayConfig = weekAvailable.find(wa => wa.numberDay === startInternalDay);

    if (!dayConfig) {
        return true; // The day is not enabled at all
    }

    // Convert start and end times to minutes from midnight for easy comparison
    const startObjMinutes = start.hour() * 60 + start.minute();
    const configStartMinutes = dayConfig.start.hour * 60 + dayConfig.start.minute;
    const configEndMinutes = dayConfig.end.hour * 60 + dayConfig.end.minute;

    if (startObjMinutes < configStartMinutes || startObjMinutes >= configEndMinutes) {
        return true;
    }

    const endInternalDay = mapDayjsToInternalDay(end.day());
    if (startInternalDay !== endInternalDay) {
        // Event crosses multiple days. Assuming overnight is outside working hours for a standard calendar.
        return true;
    }

    const endObjMinutes = end.hour() * 60 + end.minute();
    // End time can be exactly at the config end time, but not beyond
    if (endObjMinutes <= configStartMinutes || endObjMinutes > configEndMinutes) {
        return true;
    }

    return false;
};
